import React from 'react';
import PropTypes from 'prop-types';

import SubscriptionContent from '../SubscriptionContent/SubscriptionContent';

import styles from './SubscriptionContainer.module.scss';

const SubscriptionContainer = ({ children }) => {
  return <div className={styles.bns3_subscriptionContainer}>{children}</div>;
};

SubscriptionContent.propTypes = {
  children: PropTypes.node,
};
export default SubscriptionContainer;
